import type { RootState } from "app/redux/slices/rootReducer";

export const selectConnected = (state: RootState) => state.connection.connected;
